import { render, staticRenderFns } from "./CRMSearchAlertsDisplay.vue?vue&type=template&id=53d172e3&"
import script from "./CRMSearchAlertsDisplay.vue?vue&type=script&lang=js&"
export * from "./CRMSearchAlertsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports